import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Button } from '@progress/kendo-react-buttons';
import { Dialog } from '@progress/kendo-react-dialogs';
import { EditorUtils } from '@progress/kendo-react-editor';
import './index.scss';

const insertImageFiles = ({ view, files, nodeType, position, attrs = {}, prefix }) => {
    if (EditorUtils.canInsert(view.state, nodeType)) {
        files.forEach(file => {

            window.cet.microservices.nairobiapi.fileUpload.upload({
                container: 'uploads',
                prefix: prefix,
                file: file
            }).then(url => {
                const image = nodeType.createAndFill({ ...attrs, src: url });
                
                if (position) {
                    view.dispatch(view.state.tr.insert(position.pos, image));
                } else {
                    EditorUtils.insertNode(view, image, true);
                }
            });

            //base64
            //let reader = new FileReader();
            //reader.onload = function(e) {
            //    const image = nodeType.createAndFill({ ...attrs, src: e.target.result });
            //    if (position) {
            //        view.dispatch(view.state.tr.insert(position.pos, image));
            //    } else {
            //        EditorUtils.insertNode(view, image, true);
            //    }
            //};
            //reader.readAsDataURL(file);
        });
    }
};

class EditorImageUploader extends React.Component {
    state = { selected: 0, files: [], isDragging: false, previewLink: false, error: false };

    src = null;
    altText = null;
    title = null;
    width = null;
    height = null;

    onTabSelect = event => this.setState({ selected: event.selected, files: [] });

    onClose = () => this.props.onClose.call(undefined);

    onAddFiles = (event) => this.setState({ files: event.newState.map(f => f.getRawFile && f.getRawFile()).filter(f => f) });

    onInsert = () => {
        const { view, imageNode } = this.props;
        const { files } = this.state;
        const nodes = view.state.schema.nodes;
        const nodeType = nodes[imageNode];
        const data = {
            src: this.src ? this.src.value : null,
            title: this.title ? this.title.value : null,
            alt: this.altText ? this.altText.value : null,
            width: this.width ? this.width.value : null,
            height: this.height ? this.height.value : null
        };

        const attrs = Object.keys(data)
            .filter(key => data[key] !== null && data[key] !== '')
            .reduce((acc, curr) => Object.assign(acc, { [curr]: data[curr] }), {});
        
        if (files.length) {
            insertImageFiles({ view, files, nodeType, attrs, prefix: this.props.prefix });
        } else {
            const newImage = nodeType.createAndFill(attrs);
            EditorUtils.insertNode(view, newImage, true);
        }

        view.focus();
        this.onClose();
    }

    isDraggingOn = () => {
        this.setState({isDragging: true});
    };
    isDraggingOff = () => {
        this.setState({isDragging: false});
    };

    showError = (errorMas) => {
        this.setState({error: errorMas});
        setTimeout(() => {
            try{
                this.setState({error: false});
            }
            catch(ex){}
        }, 2000)
    };

    uploadFile = (files) => {
        if (!files || files.length !== 1) {
            this.showError(this.props.localization.labels.thumbnailUploader.select_one_image);
            return;
        }

        var file = files[0];
        var fileSize = file.size ? file.size : 0;
        var fileType = file.type ? file.type.toLowerCase() : "";
        if (fileSize > 5 * 1024 * 1024) { // 5MB
            this.showError(this.props.localization.labels.thumbnailUploader.max_file_size);
            return;
        }
        if (["image/gif", "image/jpg", "image/jpeg", "image/png"].indexOf(fileType) < 0) {
            this.showError(this.props.localization.labels.thumbnailUploader.unsupported_file_format);
            return;
        }

        var that = this;
        var reader = new FileReader();
        reader.onloadend = () => {
            that.setState({previewLink: reader.result});
        };
        reader.readAsDataURL(file);

        this.setState({ files: [file]});
    };

    render() {
        const { view, imageNode } = this.props;
        const state = view && view.state;
        let attrs = {};

        if (state && state.selection.node &&
            state.selection.node.type === state.schema.nodes[imageNode]) {
            attrs = state.selection.node.attrs;
        }

        return ReactDOM.createPortal(
            (
                <Dialog
                    title={this.props.localization.labels.editorImageUploader.insert_image}
                    onClose={this.onClose}
                    dir={this.props.localization.labels.dir}
                >
                        <div className="k-edit-form-container pt-3 pb-3">
                            <div className="k-edit-label">
                                <label htmlFor="k-editor-image-width">
                                    {this.props.localization.labels.editorImageUploader.image}
                                </label>
                            </div>
                            <div className="k-edit-field">
                                <div className="app-uploader--editorImage-dropzone"
                                    data-isDragging={this.state.isDragging ? 1 : 0}
                                    onDragEnter={this.isDraggingOn}
                                    onDragOver={this.isDraggingOn}
                                    onDragLeave={this.isDraggingOff} 
                                    onDrop={(e) => {
                                        this.isDraggingOff();
                                        this.uploadFile(e.dataTransfer.files);
                                    }}
                                    onClick={() => {
                                        var that = this;
                                        var inputFile = document.createElement("input");
                                        inputFile.type = "file";
                                        inputFile.accept = ".jpeg, .jpg, .png, .gif";
                                        inputFile.onchange = function (e) {
                                            that.uploadFile(e.target.files);
                                        };
                                        inputFile.click();
                                    }}
                                >
                                    {(this.state.previewLink || attrs.src) && <div className="app-uploader--editorImage-preview" style={{ "background-image": "url('" + (this.state.previewLink || attrs.src) + "')" }}></div>}
                                    <div className="app-uploader--editorImage-drag_tooltip">
                                        {!this.state.error && <span><div className="k-icon k-i-upload"></div>{this.props.localization.labels.thumbnailUploader.choose_image}</span>}
                                    </div>
                                    <div className="app-uploader--editorImage-error">{this.state.error && <span><div className="k-icon k-i-exception"></div>{this.state.error}</span>}</div>
                                </div>
                            </div>
                            <div className="k-edit-label">
                                <label htmlFor="k-editor-image-alt">
                                    {this.props.localization.labels.editorImageUploader.alternate_text}
                                </label>
                            </div>
                            <div className="k-edit-field" style={{display: "none"}}>
                                <input
                                    type="text"
                                    className="k-textbox"
                                    id="k-editor-image-alt"
                                    defaultValue={attrs.src}
                                    ref={e => this.src = e}
                                />
                            </div>
                            <div className="k-edit-field">
                                <input
                                    type="text"
                                    className="k-textbox"
                                    id="k-editor-image-alt"
                                    defaultValue={attrs.alt}
                                    ref={e => this.altText = e}
                                />
                            </div>
                            <div className="k-edit-label">
                                <label htmlFor="k-editor-image-title">
                                    {this.props.localization.labels.editorImageUploader.title}
                                </label>
                            </div>
                            <div className="k-edit-field">
                                <input
                                    type="text"
                                    className="k-textbox"
                                    id="k-editor-image-title"
                                    defaultValue={attrs.title}
                                    ref={e => this.title = e}
                                />
                            </div>
                            <div className="k-edit-label">
                                <label htmlFor="k-editor-image-width">
                                    {this.props.localization.labels.editorImageUploader.width}
                                </label>
                            </div>
                            <div className="k-edit-field">
                                <input
                                    type="text"
                                    className="k-textbox"
                                    id="k-editor-image-width"
                                    defaultValue={attrs.width}
                                    ref={e => this.width = e}
                                />
                            </div>
                            <div className="k-edit-label">
                                <label htmlFor="k-editor-image-height">
                                    {this.props.localization.labels.editorImageUploader.height}
                                </label>
                            </div>
                            <div className="k-edit-field">
                                <input
                                    type="text"
                                    className="k-textbox"
                                    id="k-editor-image-height"
                                    defaultValue={attrs.height}
                                    ref={e => this.height = e}
                                />
                            </div>
                            <div className={'text-right'} style={{ clear: 'both' }}>
                                <Button onClick={this.onClose}>{this.props.localization.labels.editorImageUploader.cancel}</Button>
                                <Button onClick={this.onInsert} primary={true}>{this.props.localization.labels.editorImageUploader.insert}</Button>
                            </div>
                        </div>
                    <style>
                        {`.k-dropzone { width: 100%; }`}
                    </style>
                </Dialog>
            ),
            document.body);
    }
}

export default EditorImageUploader;